/**
 * i18next initialisation — English + Marathi.
 *
 * - Persists the user's choice in localStorage under key "uid_lang".
 * - Auto-detects on first visit from navigator language / query string.
 * - Falls back to English for any missing key so the UI never shows blanks.
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import mr from "./locales/mr.json";

export const SUPPORTED_LANGS = [
  { code: "en", label: "English", native: "English" },
  { code: "mr", label: "Marathi", native: "मराठी" },
];

export const LS_KEY = "uid_lang";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      mr: { translation: mr },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "mr"],
    interpolation: { escapeValue: false }, // React already escapes
    returnEmptyString: false,
    detection: {
      order: ["localStorage", "querystring", "navigator", "htmlTag"],
      lookupLocalStorage: LS_KEY,
      lookupQuerystring: "lang",
      caches: ["localStorage"],
    },
  });

// Keep <html lang="…"> in sync so screen-readers pick the right language.
const syncHtmlLang = (lng) => {
  if (typeof document !== "undefined") document.documentElement.lang = lng;
};
syncHtmlLang(i18n.language || "en");
i18n.on("languageChanged", syncHtmlLang);

export default i18n;
